<template>
  <div>
    <div v-if="data[activeResourceType] && data[activeResourceType].length > 0">
      <!-- PAGINATION TOP -->
      <fob-entity-list-pagination
        @update:current="onPageChange"
        :disable-switch="true"
        :per-page="config[activeResourceType].perPage"
        :page="config[activeResourceType].page"
        :total="total[activeResourceType]"
      >
      </fob-entity-list-pagination>
      <!-- LIST OF COMPACTED ENTITIES -->
      <!-- <div class="fob-entity-compact-view">
        <div>
          <ul style="padding: 1em">
            <li v-for="item in data[activeResourceType]" :key="item._id" style="margin-bottom: 1rem">
              <div class="fob-entity-compact columns">
                <div class="column is-narrow fob-hide-in-print" style="width: 5rem">
                  <b-field addon>
                    <router-link class="control"
                      :to="{ name: 'anzeigen_einzeln',
                            params: {
                              resourceId: item._id,
                              resourceType: item._entityName.split('.').splice(-1)[0].toLowerCase()
                            }
                          }"
                    >
                      <b-tooltip square position="is-top" :label="$gettext('component.entity.compact.details')">
                        <b-icon icon="search" type="is-aquamarine"></b-icon>
                      </b-tooltip>
                    </router-link>
                    <router-link class="control"
                      v-if="userCanEditByKostenstelle(data)"
                      :to="{ name: 'editieren',
                            params: {
                              resourceId: item._id,
                              resourceType: item._entityName.split('.').splice(-1)[0].toLowerCase()
                            }
                          }"
                    >
                      <b-tooltip square position="is-top" :label="$gettext('component.entity.compact.edit')">
                        <b-icon icon="edit" type="is-aquamarine"></b-icon>
                      </b-tooltip>
                    </router-link>
                    <span
                      :class="{ 'fob-menu-is-disabled': !maco.loggedIn }"
                      style="cursor: pointer;"
                      @click="favourResearchActivity({
                        resourceId: item._id,
                        resourceType: item._entityName.split('.').splice(-1)[0].toLowerCase()
                      })"
                    >
                      <b-tooltip
                        square
                        position="is-top"
                        :label="isFavouredResearchActivity({
                          resourceType: item._entityName.split('.').splice(-1)[0].toLowerCase(),
                          resourceId: item._id
                        }) ?
                          $gettext('component.entity.compact.favour.deselect') :
                          $gettext('component.entity.compact.favour.select')"
                      >
                        <b-icon :icon="isFavouredResearchActivity({
                          resourceType: item._entityName.split('.').splice(-1)[0].toLowerCase(),
                          resourceId: item._id
                        }) ? 'star' : 'star-o'" type="is-aquamarine"></b-icon>
                      </b-tooltip>
                    </span>
                  </b-field>
                </div>
                <div class="column">
                  <div v-html="item.html[currentLocale]"></div>
                </div>
              </div>
            </li>
          </ul>
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        </div>
      </div> -->
      <div class="fob-entity-compact-view">
        <fob-entity-list-compact-cyan
          :data="data[activeResourceType]"
          :show-publication-type="activeResourceType === 'publikation'"
          :loading="isLoading"
          entityDetailsRoute="anzeigen_einzeln"
          entityEditRoute="editieren"
          show-star="true"
        ></fob-entity-list-compact-cyan>
      </div>
      <!-- PAGINATION BOTTOM -->
      <fob-entity-list-pagination
        @update:current="onPageChange"
        :disable-switch="true"
        :per-page="config[activeResourceType].perPage"
        :page="config[activeResourceType].page"
        :total="total[activeResourceType]"
      >
      </fob-entity-list-pagination>
    </div>
    <!-- No data hint -->
    <div v-else style="padding: 1rem;" class="fob-public-view-no-data">
      <div class="columns">
        <div class="column" style="max-width: 50px;">
          <b-icon icon="exclamation" type="is-garnet"></b-icon>
        </div>
        <div class="column">
          <em><translate>list.noData</translate></em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import EntityListCompactCyan from '@/components/EntityListCompactCyan'
import EntityListPagination from '@/components/EntityListPagination'
import AboutMeHelper from '@/components/mixins/AboutMeHelper'

export default {
  name: 'fob-aboutme-list-compact',
  mixins: [AboutMeHelper],
  computed: {
    ...mapGetters({
      data: 'aboutme/getData',
      config: 'aboutme/getConfig',
      schema: 'aboutme/getSchema',
      total: 'aboutme/getTotal',
      isLoading: 'aboutme/isLoading'
    })
  },
  methods: {
    onPageChange (page) {
      this.$store.dispatch('aboutme/changePage', {
        resourceType: this.activeResourceType,
        page
      })
      this.loadAsyncData()
    }
  },
  components: {
    'fob-entity-list-compact-cyan': EntityListCompactCyan,
    'fob-entity-list-pagination': EntityListPagination
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/aboutme/AboutMeListCompact.vue